import User from '../models/user/User';
import apiService from './ApiService';

export class UserService {
  async findAll(): Promise<User[]> {
    return (await apiService.get<User[]>('/api/users/findAll', {})).data;
  }

  async findCustomers() {
    return (await apiService.get('/api/users/findAllCustomers', {})).data;
  }

  async save(data) {
    const response = await apiService.post('/api/users', data);
        return response.data;
  }

  async findSingleRecord(id: string): Promise<User> {
    return (await apiService.get<User>(`/api/users/findSingleRecord/${id}`))
      .data;
  }

  async findOne(id: string) {
    return (await apiService.get(`/api/users/${id}`)).data;
  }

  async findTeam(id: string) {
    return (await apiService.get(`/api/users/team/${id}`)).data;
  }

  async getImage(): Promise<void> {
    await apiService.get(`/api/users/filename`);
  }

  async matchPassword(id, data): Promise<string> {
    const response = await apiService.post(
      `/api/users/matchPassword/${id}`,
      data,
    );
    return response.data;
  }
  
  async update(id: string, body) {
    await apiService.put(`/api/users/${id}`, body);
  }

  async delete(id: string): Promise<void> {
    await apiService.put(`/api/users/delete/${id}`);
  }
}

const userService = new UserService();
export { userService as default };
